import React, { memo } from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEFAULT_PAGINATION } from '../../../constants';

const Pagination = ({ currentPage, pageSize, pageCount, disabled, onChangePage, onChangeCustomPage }) => {
     const totalCount = pageCount ? Math.ceil(pageCount / pageSize) : 0;

     if (totalCount < 2) {
          return null;
     }

     return (
          <div className={classNames('pagination-wrapper', { disabled })}>
               <span
                    className={classNames('first-page', {
                         disabled: currentPage === 1,
                    })}
                    onClick={() => onChangeCustomPage(1)}
               >
                    <a href={`/1`} className="page-link" tabIndex="0" role="button" aria-label="First page" rel="first-page">
                         &laquo;
                    </a>
               </span>
               <ReactPaginate
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousLabel="&lsaquo;"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextLabel="&rsaquo;"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={currentPage - 1}
                    pageCount={totalCount}
                    onPageChange={onChangePage}
               />
               <span
                    className={classNames('last-page', {
                         disabled: currentPage === totalCount,
                    })}
                    onClick={() => onChangeCustomPage(totalCount)}
               >
                    <a href={`/${totalCount}`} className="page-link" tabIndex="0" role="button" aria-label="Last page" rel="last-page">
                         &raquo;
                    </a>
               </span>
          </div>
     );
};

Pagination.propTypes = {
     currentPage: PropTypes.number,
     pageSize: PropTypes.number,
     pageCount: PropTypes.number,
     disabled: PropTypes.bool,
     onChangePage: PropTypes.func,
     onChangeCustomPage: PropTypes.func,
};

Pagination.defaultProps = {
     currentPage: DEFAULT_PAGINATION.PAGE, // Start from 0 -> Active page 1
     pageSize: DEFAULT_PAGINATION.PAGE_SIZE,
};

export default memo(Pagination);
